import type { ReactNode } from 'react'

/**
 * Shared shape for the policy pages, so the three of them cannot drift apart in
 * layout while saying different things.
 *
 * The reading measure is capped inside the page gutter rather than centred on
 * its own, so these start on the same left edge as every other band.
 */
export default function PolicyPage({
  title,
  intro,
  children,
}: {
  title: string
  intro: string
  children: ReactNode
}) {
  return (
    <div className="page-shell py-10">
      <div className="flex max-w-3xl flex-col gap-6">
        <h1 className="text-3xl font-black tracking-tight">{title}</h1>
        <p className="text-ink-muted">{intro}</p>
        {children}
      </div>
    </div>
  )
}

export function Section({ id, heading, children }: { id: string; heading: string; children: ReactNode }) {
  return (
    <section aria-labelledby={id}>
      <h2 id={id} className="text-lg font-bold">
        {heading}
      </h2>
      <div className="mt-2 space-y-3 text-ink-muted">{children}</div>
    </section>
  )
}
